import React, {useEffect} from 'react'
import {Navigate, Route, Routes, Outlet, useNavigate} from 'react-router-dom'
import {PageTitle, useLayout} from '../../../_metronic/layout/core'
import {HeaderTabs} from './HeaderTabs'
import {InitialAssignment} from './initial-assignment'
import {StockIn} from './stock-in'
import {StockOut} from './stock-out'
import {StockTransfer} from './stock-transfer'
import {StockAdjustment} from './stock-adjustment'

const StockManagement: React.FC = () => {
  const {company, financialYear} = useLayout()
  const navigate = useNavigate()

  useEffect(() => {
    if (!company || !company.value || !financialYear || !financialYear.value) {
      navigate('/companies')
    }
  }, [company?.value, financialYear?.value])

  return (
    <Routes>
      <Route
        element={
          <>
            <HeaderTabs />
            <Outlet />
          </>
        }
      >
        <Route
          path='initial-assignment'
          element={
            <>
              <PageTitle>Initial Stock Assignment</PageTitle>
              <InitialAssignment />
            </>
          }
        />
        <Route
          path='in-purchases'
          element={
            <>
              <PageTitle>Stock In</PageTitle>
              <StockIn />
            </>
          }
        />
        <Route
          path='out-sales'
          element={
            <>
              <PageTitle>Stock Out</PageTitle>
              <StockOut />
            </>
          }
        />
        <Route
          path='transfer'
          element={
            <>
              <PageTitle>Stock Transfer</PageTitle>
              <StockTransfer />
            </>
          }
        />
        <Route
          path='adjustments'
          element={
            <>
              <PageTitle>Stock Adjustments</PageTitle>
              <StockAdjustment />
            </>
          }
        />
        <Route index element={<Navigate to='/stock/initial-assignment' />} />
      </Route>
    </Routes>
  )
}

export default StockManagement
